/**
 * Fade-Bottom / Blue-Violet-Red.
 */ var BlueVioletRed = [
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '911',
        rotate: -50,
        blur: 21.1,
        x: '-281',
        y: '-605'
    },
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '732',
        rotate: 120,
        blur: 21.3,
        x: '1028',
        y: '-390'
    },
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '971',
        rotate: 120,
        blur: 19.3,
        x: '278',
        y: '-606'
    }
];

export { BlueVioletRed as default };
//# sourceMappingURL=blue-violet-red.es.js.map
